<template>
    <div class="footer">
        <!-- © 2022
        <a href="https://www.nwmissouri.edu/academics/ltc/learning/index.htm" target="_blank"> Learning & Teaching
            Center </a> -->

    </div>
</template>


<style scoped>
.footer {
    background-color: #006747;
    text-align: center;
    color: whitesmoke;
    padding: 10px;
    margin-top: 70px;
}

a {
    color: white;
}

a:hover {
    color: white;
}
</style>